import { Icon } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { forwardRef } from 'react';

import { useQueueDashboardQueueContext } from '../../queueDashboardQueue.context';

import styles from './queueDashboardQueueDragHandle.module.scss';

type QueueDashboardQueueDragHandleProps = {
  isVisible?: boolean;
};

export const QueueDashboardQueueDragHandle = forwardRef<
  HTMLDivElement | HTMLTableCellElement,
  QueueDashboardQueueDragHandleProps
>(function QueueDashboardQueueDragHandle({ isVisible }, ref): JSX.Element {
  const { layout = 'default' } = useQueueDashboardQueueContext();

  return (
    <div
      ref={ref}
      className={classNames(styles.root, {
        [styles.rootHidden]: !isVisible,
        [styles.rootDefault]: layout === 'default',
        [styles.rootCompact]: layout === 'compact',
      })}
    >
      <Icon name="drag" />
    </div>
  );
});
